export const BASE_URL = "https://marketingstore.nerdmonster.com/api/";


export function getUrl(url) {
  return `${BASE_URL}proxy?url=${url}`;
}
